import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";

const App = () => {
  return (
    <div className="main-content">
      <ScrollToTop />
      <main id="main-content">
        <HomePage />
      </main>
      <Footer />
    </div>
  );
};

export default App;
